import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { applicationConfig } from './app/app.config';
import * as Sentry from '@sentry/angular';
import moment from 'moment';
import 'moment/locale/cs';

moment.locale('cs');
import { environment } from './environments/environment';
import { CHUNK_ERROR_PATTERN, isChunkReloadPending } from './app/core/chunk-error/chunk-error-reload.service';

// Detect Playwright tests
// 1. Check user agent for Headless browsers
// 2. Check for Playwright-specific properties
const isPlaywright = /HeadlessChrome|Headless/.test(navigator.userAgent) || (window as any).__playwright !== undefined || navigator.webdriver === true;

Sentry.init({
    dsn: environment.sentry.dsn,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: true,
            maskAllInputs: true,
            blockAllMedia: true,
        }),
    ],
    // Disable Sentry for Playwright tests
    enabled: environment.sentry.enabled && !isPlaywright,
    sendDefaultPii: false,
    beforeSend(event) {
        const message = event.exception?.values?.[0]?.value ?? '';
        if (CHUNK_ERROR_PATTERN.test(message) && isChunkReloadPending()) {
            return null;
        }
        return event;
    },
});

bootstrapApplication(AppComponent, { ...applicationConfig, providers: [provideZoneChangeDetection(), ...applicationConfig.providers] }).catch(err => console.error(err));
